module.exports = __webpack_public_path__ + "img/06-cosmopolis-grill.012d5b59.jpg";